import src from "IMAGE";
export default { src, width: 676, height: 468, blurWidth: 0, blurHeight: 0};
